import React from "react";

const AdminOrdersPage = () => {
  return <div>AdminOrdersPage</div>;
};

export default AdminOrdersPage;
